import { PaymentMethod } from '@/enums/payment-types.enum';

export const isBankAccount = (paymentMethod: PaymentMethod) => {
  return paymentMethod == PaymentMethod.BankAccount;
};

export const isCreditCard = (paymentMethod: PaymentMethod) => {
  return paymentMethod == PaymentMethod.CreditCard;
};

export const SSChangePaymentDetailsRules = {
  isBankAccount,
  isCreditCard,
};
